import handleCRUD from 'Helper/API/handleCRUD'
import debug from 'Helper/debugHelpers'
import { processConfig, processConfigDelete } from 'Helper/processConfig'

function appConfigReducer(state = {}, action = {}) {
  let newState = { ...state }
  switch (action.type) {
    case 'STORE_NOTIFICATION_SUBSCRIPTION_READ':
    case 'STORE_NOTIFICATION_SUBSCRIPTION_READ_ALL':
    case 'STORE_NOTIFICATION_SUBSCRIPTION_SEARCH':
      return {
        ...state,
        notification_subscriptions: handleCRUD(
          action,
          state.codes,
          'notification_subscription_id'
        )
      }
    case 'STORE_SYSTEM_STATUS_READ_ALL':
      return {
        ...state,
        email_enabled: action.result?.email_enabled
      }
    case 'STORE_MENU_CONFIG_READ_ALL':
      return {
        ...state,
        menu_config: action.result
      }
    case 'LOAD_LOCAL_APP_CONFIG':
      let CLINIC_LOCATION = localStorage.getItem('CLINIC_LOCATION')
      let CLOCK_TICK = localStorage.getItem('CLOCK_TICK')
      // if any values were null, update them with the default state values none of these are arrays or objects so ok to copy from state.
      CLINIC_LOCATION =
        CLINIC_LOCATION !== null ? Number(CLINIC_LOCATION) : state.CLINIC_LOCATION
      CLOCK_TICK = CLOCK_TICK !== null ? CLOCK_TICK : state.CLOCK_TICK
      return {
        ...state,
        CLINIC_LOCATION,
        CLOCK_TICK
      }
    case 'STORE_AUTH_PROVIDER_CONFIG_READ_ALL':
      return {
        ...state,
        auth_provider_config: action.result
      }
    case 'STORE_AUTH_PROVIDERS_READ_ALL':
      return {
        ...state,
        auth_providers: action.result
      }
    case 'PATIENT_SEARCH_HISTORY_PUSH': {
      const oldSearchHistory = state.patientSearchHistory
        ? state.patientSearchHistory.filter(
            pt => pt.patient_id != action.patient.patient_id
          )
        : []
      return {
        ...state,
        patientSearchHistory: [action.patient, ...oldSearchHistory].slice(0, 10)
      }
    }
    case 'CLEAR_UI_CONFIG':
      let { element, context } = action
      //ex. newState['nurseDashboard']['windows'] = []
      if (newState[context] && newState[context][element]) {
        newState[context][element] = []
      }
      if (newState[context] && newState[context][`${element}_id`]) {
        newState[context][`${element}_id`] = null
      }
      return newState
    case 'STORE_CONFIG_READ':
    case 'STORE_CONFIG_READ_ALL':
    case 'STORE_CONFIG_SEARCH':
    case 'STORE_CONFIG_CREATE':
    case 'STORE_CONFIG_UPDATE': {
      // create a new state object
      newState = { ...state }
      if (Array.isArray(action.result)) {
        // if its an array
        // for each returned config item, set the key in the
        // state object to the new value
        action.result.forEach(config => {
          if (
            config.name.toLowerCase() === 'windows' ||
            config.name.toLowerCase() === 'screens' ||
            config.name.toLowerCase() === 'workflows' ||
            config.name.toLowerCase() === 'searchaction' ||
            config.name.toLowerCase() === 'quickaccess' ||
            config.name.toLowerCase() === 'header' ||
            config.name.toLowerCase() === 'modals'
          ) {
            parseSectionJSONInfo(config, newState)
          } else {
            newState = processConfig(
              newState,
              config,
              /* apps */ ['*'],
              /* storeValueOnly */ true
            )
          }
        })
      } else {
        // if not an array, then its a single object
        if (
          action.result.name.toLowerCase() === 'windows' ||
          action.result.name.toLowerCase() === 'screens' ||
          action.result.name.toLowerCase() === 'workflows' ||
          action.result.name.toLowerCase() === 'searchaction' ||
          action.result.name.toLowerCase() === 'quickaccess' ||
          action.result.name.toLowerCase() === 'header' ||
          action.result.name.toLowerCase() === 'modals'
        ) {
          parseSectionJSONInfo(action.result, newState)
        } else {
          newState = processConfig(
            newState,
            action.result,
            /* apps */ ['*'],
            /* storeValueOnly */ true
          )
        }
      }
      return newState
    }
    case 'STORE_CONFIG_DELETE': {
      return processConfigDelete(state, action.result, /* apps */ ['*'])
    }
    case 'UPDATE_APP_CONFIG':
      switch (action.key) {
        case 'CLINIC_LOCATION':
          localStorage.setItem('CLINIC_LOCATION', action.value)
          return {
            ...state,
            CLINIC_LOCATION: Number(action.value)
          }
        case 'CLOCK_TICK':
          localStorage.setItem('CLOCK_TICK', action.value)
          return {
            ...state,
            CLOCK_TICK: action.value
          }
        default:
          // Update the state with the new key/value
          return {
            ...state,
            [action.key]: action.value
          }
      }
    case 'STORE_CODE_READ':
    case 'STORE_CODE_READ_ALL':
    case 'STORE_CODE_SEARCH':
    case 'STORE_CODE_CREATE':
    case 'STORE_CODE_UPDATE':
    case 'STORE_CODE_DELETE':
      return {
        ...state,
        codes: handleCRUD(action, state.codes, 'code_id')
      }
    case 'STORE_CLINIC_READ':
    case 'STORE_CLINIC_READ_ALL':
    case 'STORE_CLINIC_SEARCH':
    case 'STORE_CLINIC_CREATE':
    case 'STORE_CLINIC_UPDATE':
    case 'STORE_CLINIC_DELETE':
      return {
        ...state,
        clinics: handleCRUD(action, state.clinics, 'clinic_id')
      }
    case 'STORE_PHARMACY_READ':
    case 'STORE_PHARMACY_READ_ALL':
    case 'STORE_PHARMACY_SEARCH':
    case 'STORE_PHARMACY_CREATE':
    case 'STORE_PHARMACY_UPDATE':
    case 'STORE_PHARMACY_DELETE':
      return {
        ...state,
        pharmacies: handleCRUD(action, state.pharmacies, 'pharmacy_id')
      }
    case 'STORE_PROVIDER_READ':
    case 'STORE_PROVIDER_READ_ALL':
    case 'STORE_PROVIDER_SEARCH':
    case 'STORE_PROVIDER_CREATE':
    case 'STORE_PROVIDER_UPDATE':
    case 'STORE_PROVIDER_DELETE':
      return {
        ...state,
        providers: handleCRUD(action, state.providers, 'provider_id')
      }
    case 'STORE_PRINTER_READ':
    case 'STORE_PRINTER_READ_ALL':
    case 'STORE_PRINTER_SEARCH':
    case 'STORE_PRINTER_CREATE':
    case 'STORE_PRINTER_UPDATE':
    case 'STORE_PRINTER_DELETE':
      return {
        ...state,
        printers: handleCRUD(action, state.printers, 'printer_id')
      }
    case 'STORE_TEMPLATE_READ':
    case 'STORE_TEMPLATE_READ_ALL':
    case 'STORE_TEMPLATE_SEARCH':
    case 'STORE_TEMPLATE_CREATE':
    case 'STORE_TEMPLATE_UPDATE':
    case 'STORE_TEMPLATE_DELETE':
      if (Array.isArray(action.result)) {
        action.result = action.result.map(template => {
          return template
        })
      } else {
        action.result = { ...action.result }
      }
      return {
        ...state,
        templates: handleCRUD(action, state.templates, 'template_id')
      }
    case 'STORE_PROFILE_READ':
    case 'STORE_PROFILE_READ_ALL':
    case 'STORE_PROFILE_SEARCH':
    case 'STORE_PROFILE_CREATE':
    case 'STORE_PROFILE_UPDATE':
    case 'STORE_PROFILE_DELETE':
      return {
        ...state,
        profiles: handleCRUD(action, state.profiles, 'profile_id')
      }
    case 'STORE_USER_SEARCH':
    case 'STORE_USER_READ':
    case 'STORE_USER_READ_ALL':
    case 'STORE_USER_CREATE':
    case 'STORE_USER_UPDATE':
    case 'STORE_USER_DELETE':
      return {
        ...state,
        users: handleCRUD(action, state.users, 'user_id')
      }
    case 'STORE_ME_READ_ALL':
    case 'STORE_ME_UPDATE':
      let users
      if (state.users.find(usr => usr.user_id == action.result.user_id)) {
        users = state.users.map(user => {
          if (user.user_id == action.result.user_id) {
            return action.result
          } else {
            return user
          }
        })
      } else {
        users = [...state.users, { ...action.result }]
      }
      return {
        ...state,
        users
      }
    case 'STORE_ACCESS_CREATE':
    case 'STORE_ACCESS_DELETE':
      // access is for user locking and unlocking and returns a user object so we just
      // need to replace the existing user object.
      return {
        ...state,
        users: state.users.map(user => {
          if (action.result.locked_at === undefined) {
            // this needs to be explicitly set to null so that it will overwrite
            // the previous timestamp during an unlock in the spread below.
            action.result.locked_at = null
          }
          return user.user_id === action.result.user_id
            ? { ...user, ...action.result }
            : user
        })
      }
    case 'STORE_USER_GROUP_SEARCH':
    case 'STORE_USER_GROUP_READ':
    case 'STORE_USER_GROUP_READ_ALL':
    case 'STORE_USER_GROUP_CREATE':
    case 'STORE_USER_GROUP_UPDATE':
    case 'STORE_USER_GROUP_DELETE':
      return {
        ...state,
        userGroup: handleCRUD(action, state.userGroup, 'user_group_id')
      }
    case 'STORE_DOSING_PLAN_SEARCH':
    case 'STORE_DOSING_PLAN_READ':
    case 'STORE_DOSING_PLAN_READ_ALL':
    case 'STORE_DOSING_PLAN_CREATE':
    case 'STORE_DOSING_PLAN_UPDATE':
    case 'STORE_DOSING_PLAN_DELETE':
      return {
        ...state,
        dosingplans: handleCRUD(action, state.dosingplans, 'dosing_plan_id')
      }
    case 'STORE_TREATMENT_PLAN_SEARCH':
    case 'STORE_TREATMENT_PLAN_READ':
    case 'STORE_TREATMENT_PLAN_READ_ALL':
    case 'STORE_TREATMENT_PLAN_CREATE':
    case 'STORE_TREATMENT_PLAN_UPDATE':
    case 'STORE_TREATMENT_PLAN_DELETE':
      return {
        ...state,
        treatmentplans: handleCRUD(
          action,
          state.treatmentplans,
          'treatment_plan_id'
        )
      }
    case 'STORE_QUESTION_READ':
    case 'STORE_QUESTION_READ_ALL':
    case 'STORE_QUESTION_SEARCH':
    case 'STORE_QUESTION_CREATE':
    case 'STORE_QUESTION_UPDATE':
    case 'STORE_QUESTION_DELETE':
      return {
        ...state,
        questions: handleCRUD(action, state.questions, 'question_id')
      }
    case 'STORE_QUESTIONNAIRE_SEARCH':
    case 'STORE_QUESTIONNAIRE_READ':
    case 'STORE_QUESTIONNAIRE_READ_ALL':
    case 'STORE_QUESTIONNAIRE_CREATE':
    case 'STORE_QUESTIONNAIRE_UPDATE':
    case 'STORE_QUESTIONNAIRE_DELETE':
      return {
        ...state,
        questionnaires: handleCRUD(
          action,
          state.questionnaires,
          'questionnaire_id'
        )
      }
    case 'STORE_PURCHASE_ORDER/STATUS_READ':
    case 'STORE_PURCHASE_ORDER/STATUS_READ_ALL':
    case 'STORE_PURCHASE_ORDER/STATUS_SEARCH':
    case 'STORE_PURCHASE_ORDER/STATUS_CREATE':
    case 'STORE_PURCHASE_ORDER/STATUS_UPDATE':
    case 'STORE_PURCHASE_ORDER/STATUS_DELETE':
      return {
        ...state,
        purchaseOrderStatuses: handleCRUD(
          action,
          state.purchaseOrderStatuses,
          'purchase_order_status_id'
        )
      }
    case 'STORE_TREATMENT_SET/STATUS_READ':
    case 'STORE_TREATMENT_SET/STATUS_READ_ALL':
    case 'STORE_TREATMENT_SET/STATUS_SEARCH':
    case 'STORE_TREATMENT_SET/STATUS_CREATE':
    case 'STORE_TREATMENT_SET/STATUS_UPDATE':
    case 'STORE_TREATMENT_SET/STATUS_DELETE':
      return {
        ...state,
        treatmentSetStatuses: handleCRUD(
          action,
          state.treatmentSetStatuses,
          'treatment_set_status_id'
        )
      }
    case 'STORE_ACCOUNT/STATUS_READ':
    case 'STORE_ACCOUNT/STATUS_READ_ALL':
    case 'STORE_ACCOUNT/STATUS_SEARCH':
    case 'STORE_ACCOUNT/STATUS_CREATE':
    case 'STORE_ACCOUNT/STATUS_UPDATE':
    case 'STORE_ACCOUNT/STATUS_DELETE':
      return {
        ...state,
        accountStatuses: handleCRUD(
          action,
          state.accountStatuses,
          'account_status_id'
        )
      }
    case 'STORE_SKINTEST/STATUS_READ':
    case 'STORE_SKINTEST/STATUS_READ_ALL':
    case 'STORE_SKINTEST/STATUS_SEARCH':
    case 'STORE_SKINTEST/STATUS_CREATE':
    case 'STORE_SKINTEST/STATUS_UPDATE':
    case 'STORE_SKINTEST/STATUS_DELETE':
      return {
        ...state,
        skintestStatuses: handleCRUD(
          action,
          state.skintestStatuses,
          'skintest_status_id'
        )
      }
    case 'STORE_ATTACHMENT_TAG_READ':
    case 'STORE_ATTACHMENT_TAG_READ_ALL':
    case 'STORE_ATTACHMENT_TAG_SEARCH':
    case 'STORE_ATTACHMENT_TAG_CREATE':
    case 'STORE_ATTACHMENT_TAG_UPDATE':
    case 'STORE_ATTACHMENT_TAG_DELETE':
      return {
        ...state,
        attachmentTags: handleCRUD(
          action,
          state.attachmentTags,
          'attachment_tag_id'
        )
      }
    case 'STORE_ACCOUNT_READ':
    case 'STORE_ACCOUNT_READ_ALL':
    case 'STORE_ACCOUNT_SEARCH':
    case 'STORE_ACCOUNT_CREATE':
    case 'STORE_ACCOUNT_DELETE':
      return {
        ...state,
        accounts: handleCRUD(action, state.accounts, 'account_id')
      }
    case 'STORE_ACCOUNT_UPDATE':
      // special case to account for override_undelete.
      let accountFound = false
      const newAccounts = state.accounts.map(account => {
        if (account.account_id === action.result.account_id) {
          accountFound = true
          return action.result
        } else {
          return account
        }
      })
      if (!accountFound) {
        newAccounts.push(action.result)
      }
      return {
        ...state,
        accounts: newAccounts
      }
    case 'STORE_VIAL_SIZE_READ':
    case 'STORE_VIAL_SIZE_READ_ALL':
    case 'STORE_VIAL_SIZE_SEARCH':
    case 'STORE_VIAL_SIZE_CREATE':
    case 'STORE_VIAL_SIZE_DELETE':
      return {
        ...state,
        vial_sizes: handleCRUD(action, state.vial_sizes, 'vial_size_id')
      }
    case 'STORE_COMPATIBILITY_CLASS_READ':
    case 'STORE_COMPATIBILITY_CLASS_READ_ALL':
    case 'STORE_COMPATIBILITY_CLASS_SEARCH':
    case 'STORE_COMPATIBILITY_CLASS_UPDATE':
    case 'STORE_COMPATIBILITY_CLASS_DELETE':
      return {
        ...state,
        compatibilityClasses: handleCRUD(
          action,
          state.compatibilityClasses,
          'compatibility_class_id'
        )
      }
    case 'STORE_PRINT_DIALOG_READ':
    case 'STORE_PRINT_DIALOG_READ_ALL':
    case 'STORE_PRINT_DIALOG_SEARCH':
    case 'STORE_PRINT_DIALOG_UPDATE':
      return {
        ...state,
        print_dialogs: handleCRUD(
          action,
          state.print_dialogs,
          'print_dialog_id'
        )
      }
    case 'STORE_PRIVILEGE_READ':
    case 'STORE_PRIVILEGE_READ_ALL':
    case 'STORE_PRIVILEGE_SEARCH':
      return {
        ...state,
        privileges: handleCRUD(action, state.privileges, 'privilege_id')
      }
    case 'STORE_ENT_DILUTION_TYPE_READ':
    case 'STORE_ENT_DILUTION_TYPE_READ_ALL':
    case 'STORE_ENT_DILUTION_TYPE_SEARCH':
    case 'STORE_ENT_DILUTION_TYPE_CREATE':
    case 'STORE_ENT_DILUTION_TYPE_UPDATE':
    case 'STORE_ENT_DILUTION_TYPE_DELETE':
      return {
        ...state,
        ent_dilution_types: handleCRUD(
          action,
          state.ent_dilution_types,
          'ent_dilution_type_id'
        )
      }
    case 'STORE_MANUFACTURER_READ':
    case 'STORE_MANUFACTURER_READ_ALL':
    case 'STORE_MANUFACTURER_SEARCH':
    case 'STORE_MANUFACTURER_CREATE':
    case 'STORE_MANUFACTURER_UPDATE':
    case 'STORE_MANUFACTURER_DELETE':
      return {
        ...state,
        manufacturers: handleCRUD(
          action,
          state.manufacturers,
          'manufacturer_id'
        )
      }
    case 'STORE_PROFILE_TYPE_READ':
    case 'STORE_PROFILE_TYPE_READ_ALL':
    case 'STORE_PROFILE_TYPE_SEARCH':
    case 'STORE_PROFILE_TYPE_CREATE':
    case 'STORE_PROFILE_TYPE_UPDATE':
    case 'STORE_PROFILE_TYPE_DELETE':
      return {
        ...state,
        profile_types: handleCRUD(
          action,
          state.profile_types,
          'profile_type_id'
        )
      }
    case 'STORE_STATE_READ_ALL':
      return {
        ...state,
        states: handleCRUD(action, state.states, 'sm_state_id')
      }
    case 'STORE_STATE_MACHINE_SEGMENT_UPDATE':
      const { sm_segment_id, states, name } = action.result
      // if we updated a segment we deleted the old segment and its states and recreated them, so filter
      // the existing states array to remove any states assigned to it, then concatenate the new states in.
      return {
        ...state,
        states: state.states
          .filter(state => state.sm_segment_id != sm_segment_id)
          .concat(
            states.map(state => {
              return { ...state, segment: { name } }
            })
          )
      }
    case 'STORE_TIMEZONE_READ_ALL':
      return {
        ...state,
        timezones: action.result
      }
    case 'STORE_PATIENT_NAME_FORMAT_READ_ALL':
      return {
        ...state,
        patientNameFormats: action.result
      }
    default:
      return state
  }
}

export default appConfigReducer

export const parseSectionJSONInfo = (config, newState) => {
  let value
  try {
    value = JSON.parse(config.value)
  } catch (e) {
    // it wasn't json
    value = config.value
  }

  try {
    // handle a section as an object in its own right
    const section = { ...newState[config.section] } || {}
    section[config.name] = value
    section[config.name + '_id'] = config.config_id
    newState[config.section] = section
  } catch (Exception) {
    debug.logObject('Exception decoding config item', Exception)
  }
}
